import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'msgparse' })
export class MsgparsePipe implements PipeTransform {

  transform(body: any, isPreview: boolean = false, type: string = null): any {

    let result = body;

    if (!isPreview) {
      //URL REPLACEMENT
      const regexImg = /(https:\/\/cdnpremium\.s3\.amazonaws\.com\/i\/)([0-9]*G)/gi;
      result = result.replace(regexImg, '<img src="$&" target="_system"/>');

      // eslint-disable-next-line max-len
      const regex1 = /(?:(?:https?|ftp|file):\/\/(?!cdnpremium)|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gi;
      // eslint-disable-next-line prefer-const
      result = result.replace(regex1, '<a href="$&" target="_system">$&</a>');
      const regex2 = />https?:\/\//gi;
      result = result.replace(regex2, '>');

      const regex2a = /\/\/(https|http|ftp|file):\/\//gi;
      result = result.replace(regex2a, '$1:\/\/');

      //EMAIL REPLACEMENT
      const regex3 = /([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)/gi;
      // eslint-disable-next-line prefer-const
      result = result.replace(regex3, '<a href="mailto:$&" target="_blank">$&</a>');

      //PHONE REPLACEMENT
      // eslint-disable-next-line max-len
      const regex4 = /^((?!cdnpremium).)*$((\+34|0034|34)( |-| -|- | - )?)?(6|7|8|9)( |-| -|- | - )?([0-9]){2}( |-| -|- | - )?([0-9]){2}( |-| -|- | - )?([0-9]){1}( |-| -|- | - )?([0-9]){1}( |-| -|- | - )??([0-9]){2}/gi;
      // eslint-disable-next-line prefer-const
      result = result.replace(regex4, '<a href="tel:$&" target="_blank">$&</a>');
  
    }
    else {
      switch(type) {
        case 'text':
        case 'system':
          const txt = body.replace(/(<([^>]+)>)/gi, '');
          result = txt ? (txt.length <= 100 ? txt : txt.substring(0, 97) + '...') : '';
          break;
        case 'audio':
          result = 'Ha enviado un audio';
          break;
        case 'video':
          result = 'Ha enviado un video';
          break;
        case 'image':
          result = 'Ha enviado una imagen';
          break;
        case 'document':
          result = 'Ha enviado un documento';
      }
    }

    return result;
  }
}

